import { render, staticRenderFns } from "./InfiniteScroll.vue?vue&type=template&id=56c6f49c&scoped=true&"
import script from "./InfiniteScroll.vue?vue&type=script&lang=js&"
export * from "./InfiniteScroll.vue?vue&type=script&lang=js&"
import style0 from "./InfiniteScroll.vue?vue&type=style&index=0&id=56c6f49c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6f49c",
  null
  
)

export default component.exports